import styled from 'styled-components'

export const MapContainer = styled.div`
    margin-left: 50%;
    width: 50vw;
    height: 25vw;
    margin-top: -25rem;
`